import { useState, memo } from 'react';
import { Link } from 'react-router-dom';
import { Globe, Menu, X } from 'lucide-react';
import { useLang } from './context/LangContext';

const NAV_LINKS = [
  ['/services', 'services'],
  ['/why-us',   'whyUs'],
];

const Navbar = () => {
  const { t, lang, toggleLang } = useLang();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="navbar-wrap">
      {/* ── Inner bar ── */}
      <div className="navbar-inner">
        {/* Logo — w_240,q_auto,f_auto: كانت الصورة بتتحمل بحجمها الخام
            (1536×1024 تقريبًا 2 ميجابايت) في مكان معروض فيه 120×120 بس.
            دلوقتي بتتحمل بمقاس 240px (2x للريتينا) بجودة وصيغة محسّنة تلقائيًا. */}
        <Link to="/" className="navbar-logo-link">
          <img
            src="https://res.cloudinary.com/dsh6m0lko/image/upload/w_240,q_auto,f_auto/v1785027280/Zeiia_gft6aa.png"
            alt="zeiia logo"
            width="120"
            height="120"
            fetchpriority="high"
            className="navbar-logo-img"
          />
        </Link>

        {/* Desktop links */}
        <div className="desktop-nav navbar-desktop-links">
          {NAV_LINKS.map(([to, key]) => (
            <Link key={to} to={to} className="navbar-link">
              {t.nav[key]}
            </Link>
          ))}

          {/* Lang toggle */}
          <button onClick={toggleLang} className="navbar-lang-btn">
            <Globe size={14} /> {lang === 'ar' ? 'English' : 'عربي'}
          </button>

          {/* CTA */}
          <Link to="/contact" className="navbar-cta">
            {t.nav.contact}
          </Link>
        </div>

        {/* Mobile icons */}
        <div className="mobile-nav navbar-mobile-icons">
          <button onClick={toggleLang} className="navbar-lang-btn-mobile">
            <Globe size={18} />
          </button>
          <button onClick={() => setIsMenuOpen(o => !o)} className="navbar-menu-toggle">
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="navbar-mobile-menu">
          {[...NAV_LINKS, ['/contact', 'contact']].map(([to, key], i, arr) => (
            <Link
              key={to} to={to}
              onClick={() => setIsMenuOpen(false)}
              className={`navbar-mobile-link ${i === arr.length - 1 ? 'is-last' : ''}`}
            >
              {t.nav[key]}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
};

export default memo(Navbar);